import { MonetaryBasis, type MonetaryBasisValue, type OptimizeRequest } from "./types";

export interface OptimizeBasis {
  depositAmount: number;
  withdrawalAmount: number;
  reservedAmount: number;
  monetaryBasis: MonetaryBasisValue;
  includeFees?: boolean;
}

export function buildOptimizeRequestBody(input: {
  depositAmount: number;
  withdrawalAmount: number;
  reservedAmount?: number;
  monetaryBasis?: MonetaryBasisValue;
}): OptimizeRequest {
  return {
    monetary_basis: input.monetaryBasis ?? MonetaryBasis.REAL,
    include_deposit_fee: false,
    include_advisory_fee: false,
    include_product_fees: false,
    include_financial_plan: false,
    reserved_amount: amountString(input.reservedAmount ?? 0),
    deposit_amount: amountString(input.depositAmount),
    withdrawal_amount: amountString(input.withdrawalAmount),
  };
}

function amountString(value: number | undefined): string {
  return typeof value === "number" && Number.isFinite(value) ? String(value) : "0";
}
